import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const TasksPage = lazy(() => import('@/pages/my-tasks/TasksPage'));

export const myTasksRoutes = [
    {
        path: 'tasks',
        element: <TasksPage />,
    },
    {
        path: 'my-tasks',
        element: <Navigate to="/tasks?tab=my-tasks" replace />,
    },
];
